// src/components/Sidebar.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  ChartBarIcon,
  ScaleIcon,
  DocumentTextIcon,
  HomeIcon,
  ChartPieIcon,
  Bars3Icon,
  ChevronLeftIcon,
  BanknotesIcon,
  ShoppingCartIcon,
} from '@heroicons/react/24/outline'; // Importing icons

interface SidebarProps {
  collapsed: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, toggleSidebar }) => {
  const navItems = [
    { name: 'Dashboard', path: '/', icon: HomeIcon },
    { name: 'General Ledger', path: '/general-ledger', icon: DocumentTextIcon },
    { name: 'Balance Sheet', path: '/balance-sheet', icon: ScaleIcon },
    { name: 'Profit & Loss', path: '/profit-loss', icon: ChartBarIcon },
    { name: 'Sales', path: '/sales-report', icon: ChartPieIcon },
    { name: 'Purchase', path: '/purchase-report', icon: ShoppingCartIcon },
    { name: 'Outstanding Receivable', path: '/outstanding-receivable', icon: BanknotesIcon }
  ];

  return (
    <aside className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <div className={`flex ${collapsed ? 'justify-center' : 'justify-between'} items-center mb-8 ${collapsed ? 'p-0' : 'pl-1'}`}>
        {!collapsed &&
          <div className="text-2xl font-bold text-blue-600">FinReportApp</div>}
        <button
          type="button"
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <Bars3Icon className="h-7 w-8" /> : <ChevronLeftIcon className="h-5 w-5" />}
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {navItems.map((item) => (
            <li key={item.name} className="mb-4">
              <Link
                to={item.path}
                className={`flex ${collapsed ? 'justify-center' : 'items-center'} text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg p-3 transition-colors duration-200`}
              >
                <item.icon className={`h-6 w-6 ${!collapsed ? 'mr-3' : ''}`} />
                <span>{!collapsed && item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {!collapsed && (
        <div className="mt-auto pt-6 border-t border-gray-200 text-sm text-gray-500">
          &copy; {new Date().getFullYear()} FinReportApp
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
